import { render, staticRenderFns } from "./SeckillSessionGoodsList.vue?vue&type=template&id=69c31055&scoped=true"
import script from "./SeckillSessionGoodsList.vue?vue&type=script&lang=js"
export * from "./SeckillSessionGoodsList.vue?vue&type=script&lang=js"
import style0 from "./SeckillSessionGoodsList.vue?vue&type=style&index=0&id=69c31055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c31055",
  null
  
)

export default component.exports